import { render } from "./SingleImageViewer.vue?vue&type=template&id=de2bdada&scoped=true&ts=true"
import script from "./SingleImageViewer.vue?vue&type=script&lang=ts"
export * from "./SingleImageViewer.vue?vue&type=script&lang=ts"

import "./SingleImageViewer.vue?vue&type=style&index=0&id=de2bdada&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de2bdada"]])

export default __exports__